import { isFunction, omit } from '@sama/micro-dash';
import {
  Tracker,
  TrackingEvent,
} from '../../cross-team-shared/event-tracking/event-utils';
import { EventTrackingValue } from '../../team-apis/core/event-tracking';

export const defaultExperimentName = 'control';
export class SegmentTracker implements Tracker {
  currentUserId?: number | string;

  constructor(
    private product: string,
    private segmentClientAccessor: () => any,
  ) {}

  track(
    event: TrackingEvent,
    {
      experiment = defaultExperimentName,
      isInteractive = true,
    }: {
      experiment?: string;
      isInteractive?: boolean;
    },
  ) {
    const value = omit(event, 'id');
    this.callIdentify(value);
    this.segmentClientAccessor().track(
      event.id,
      this.buildValue(value, experiment, isInteractive),
    );
  }

  identify(userId?: number | string) {
    this.segmentClientAccessor().identify(userId);
  }

  private callIdentify(value?: EventTrackingValue) {
    if (
      value !== undefined &&
      value.user_id !== undefined &&
      (this.currentUserId === undefined || this.currentUserId !== value.user_id)
    ) {
      this.assignCurrentUser(value.user_id);
      this.identify(this.currentUserId);
    }
  }

  private buildValue(
    value: EventTrackingValue | undefined,
    experiment: string,
    isInteractive: boolean,
  ) {
    return {
      product: this.product,
      experiment,
      is_interactive: isInteractive,
      ...value,
    };
  }

  private assignCurrentUser(userId: number | string | (() => number | string)) {
    if (isFunction(userId)) {
      this.currentUserId = userId();
    } else {
      this.currentUserId = userId;
    }
  }
}
